export enum UnsavedChangesArea {
  EnrichVacancyModal_EnrichedVersion = 'EnrichVacancyModal_EnrichedVersion',
  EnrichVacancyModal_JobPreview = 'EnrichVacancyModal_JobPreview',
  ReachoutInterviewModal_Content = 'ReachoutInterviewModal_Content',
  FeatureTogglesModal = 'FeatureTogglesModal',
}

export type AreaState = {
  changeDetectors: Array<() => boolean>;
};

export type UnsavedChangesStore = {
  areas: Record<UnsavedChangesArea, AreaState>;

  registerChangeDetector: (area: UnsavedChangesArea, detector: () => boolean) => void;
  unregisterChangeDetector: (area: UnsavedChangesArea, detector: () => boolean) => void;
  checkAreaChanges: (area: UnsavedChangesArea) => boolean;
};
